const CAMPOS = [
  { key: 'woofer', label: 'Drivers' },
  { key: 'frequencia_de_resposta', label: 'Frequência de resposta' },
  { key: 'impedancia', label: 'Impedância' },
  { key: 'dimensoes', label: 'Dimensões' },
  { key: 'potencia', label: 'Potência' },
  { key: 'sensibilidade', label: 'Sensibilidade' },
  { key: 'divisor_de_frequencia', label: 'Divisor de Frequência' },
  { key: 'construcao_do_gabinete', label: 'Gabinete' },
  { key: 'descricao_detalhada_do_produto', label: 'Descrição detalhada' },
];

const METAFIELD_IDENTIFIERS = CAMPOS.map(c => `{namespace: "custom", key: "${c.key}"}`).join(',\n');

const PRODUTO_FRAGMENT = `
  id
  title
  handle
  priceRange { minVariantPrice { amount currencyCode } }
  compareAtPriceRange { minVariantPrice { amount } }
  featuredImage { url(transform: { maxWidth: 500 }) }
  metafields(identifiers: [${METAFIELD_IDENTIFIERS}]) {
    namespace key value
  }
`;

const QUERY_POR_ID = `
  query ProdutoPorId($id: ID!) {
    product(id: $id) { ${PRODUTO_FRAGMENT} }
  }
`;

const QUERY_BUSCA = `
  query BuscarProdutos($query: String!) {
    products(first: 8, query: $query) {
      edges { node { ${PRODUTO_FRAGMENT} } }
    }
  }
`;

async function storefrontFetch(query, variables) {
  const res = await fetch('https://tropic-audio-woodwork.myshopify.com/api/2026-07/graphql.json', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': '5cd583aa98cbcf320dcc495a4ae0031b',
    },
    body: JSON.stringify({ query, variables }),
  });
  return res.json();
}

function formatarPreco(amount, currencyCode) {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: currencyCode || 'BRL',
  }).format(parseFloat(amount || 0));
}

function normalizarProduto(node) {
  const mfs = {};
  (node.metafields || []).forEach(mf => { if (mf) mfs[mf.key] = mf.value || ''; });
  const priceAmount = parseFloat(node.priceRange?.minVariantPrice?.amount || 0);
  const compareAmount = parseFloat(node.compareAtPriceRange?.minVariantCompareAtPrice?.amount || 0);
  const currencyCode = node.priceRange?.minVariantPrice?.currencyCode || 'BRL';
  return {
    id: node.id,
    title: node.title,
    handle: node.handle,
    image: node.featuredImage?.url || null,
    imageAlt: node.title,
    price: formatarPreco(priceAmount, currencyCode),
    priceAmount,
    compareAtPrice: compareAmount > priceAmount ? formatarPreco(compareAmount, currencyCode) : null,
    hasDiscount: compareAmount > priceAmount,
    metafields: mfs,
  };
}

function renderCabecalhoProduto(produto, colId) {
  const col = document.getElementById(colId);
  col.innerHTML = `
    ${produto.image ? `<img src="${produto.image}" alt="${produto.imageAlt}" style="width:100px;height:100px;object-fit:cover;border-radius:6px;display:block;margin-bottom:8px">` : ''}
    <strong>${produto.title}</strong><br>
    <a href="/products/${produto.handle}" style="font-size:0.85em;color:#666">Ver produto →</a>
  `;
}

function renderPreco(produto, difere) {
  if (produto.hasDiscount && produto.compareAtPrice) {
    return `<span class="preco-de">DE ${produto.compareAtPrice}</span><br>
            <span class="preco-por${difere ? ' difere' : ''}">POR ${produto.price}</span>`;
  }
  return `<span class="${difere ? 'difere' : ''}">${produto.price}</span>`;
}

function renderTabela(prodA, prodB) {
  renderCabecalhoProduto(prodA, 'col-a-titulo');
  renderCabecalhoProduto(prodB, 'col-b-titulo');

  const tbody = document.getElementById('comparar-tbody');
  let rows = '';

  // Preço
  const precoDifere = prodA.priceAmount !== prodB.priceAmount;
  rows += `<tr>
    <td><strong>Preço</strong></td>
    <td>${renderPreco(prodA, precoDifere)}</td>
    <td>${renderPreco(prodB, precoDifere)}</td>
  </tr>`;

  // Campos técnicos
  CAMPOS.forEach(({ key, label }) => {
    const valA = (prodA.metafields[key] || '').trim();
    const valB = (prodB.metafields[key] || '').trim();
    const difere = valA !== valB && (valA || valB);
    const cls = difere ? 'difere' : '';

    // ← ÚNICA MUDANÇA: renderVal agora trata rich text JSON e woofer
    const renderVal = (val) => {
      if (!val) return '—';

      // Tenta parsear como rich text JSON (ex: descricao_detalhada_do_produto)
      try {
        const parsed = JSON.parse(val);
        if (parsed?.type === 'root' && parsed?.children) {
          const renderNode = (node) => {
            if (node.type === 'text') {
              let t = node.value || '';
              if (node.bold) t = `<strong>${t}</strong>`;
              if (node.italic) t = `<em>${t}</em>`;
              if (node.underline) t = `<u>${t}</u>`;
              return t;
            }
            const children = (node.children || []).map(renderNode).join('');
            switch (node.type) {
              case 'paragraph': return `<p style="margin:0 0 6px">${children}</p>`;
              case 'heading': return `<h${node.level || 2} style="margin:0 0 4px">${children}</h${node.level || 2}>`;
              case 'list':
                return node.listType === 'ordered'
                  ? `<ol style="margin:0 0 6px;padding-left:18px">${children}</ol>`
                  : `<ul style="margin:0 0 6px;padding-left:18px">${children}</ul>`;
              case 'list-item': return `<li>${children}</li>`;
              case 'link': return `<a href="${node.url}" style="color:#c0392b">${children}</a>`;
              default: return children;
            }
          };
          const html = parsed.children.map(renderNode).join('');
          return html || '—';
        }
      } catch (e) {
        // não é JSON, continua normal
      }

      // Drivers: quebrar por \n
      if (key === 'woofer' && val.includes('\n')) {
        return val.split('\n').filter(Boolean).map(l => `<span style="display:block">${l.trim()}</span>`).join('');
      }

      return val;
    };

    rows += `<tr>
      <td><strong>${label}</strong></td>
      <td class="${cls}">${renderVal(valA) || '—'}</td>
      <td class="${cls}">${renderVal(valB) || '—'}</td>
    </tr>`;
  });

  tbody.innerHTML = rows;
  document.getElementById('comparar-tabela-wrapper').style.display = 'block';
  document.querySelector('.comparar-busca').style.display = 'none';
}

// Carregar Produto A pelo parâmetro ?product= da URL
async function carregarProdutoA() {
  const params = new URLSearchParams(location.search);
  const rawId = params.get('product');
  const wrapper = document.getElementById('comparar-produto-a');

  if (!rawId) {
    wrapper.innerHTML = '<p style="color:#c0392b">Nenhum produto informado na URL. Use <code>?product=ID</code>.</p>';
    return null;
  }

  const gid = rawId.startsWith('gid://') ? rawId : `gid://shopify/Product/${rawId}`;
  const data = await storefrontFetch(QUERY_POR_ID, { id: gid });
  const node = data?.data?.product;

  if (!node) {
    wrapper.innerHTML = '<p style="color:#c0392b">Produto não encontrado.</p>';
    return null;
  }

  const produto = normalizarProduto(node);
  wrapper.innerHTML = `
    <div style="display:flex;align-items:center;gap:12px;margin-bottom:16px;padding:12px;background:#f9f9f9;border-radius:8px">
      ${produto.image ? `<img src="${produto.image}" alt="${produto.imageAlt}" style="width:60px;height:60px;object-fit:cover;border-radius:6px">` : ''}
      <div>
        <strong>${produto.title}</strong><br>
        <span style="color:#666;font-size:0.9em">${produto.price}</span>
      </div>
    </div>
  `;
  return produto;
}

// Busca com debounce
let produtoA = null;
let debounce;

const searchInput = document.getElementById('comparar-search');
const resultados = document.getElementById('comparar-resultados');

searchInput.addEventListener('input', () => {
  clearTimeout(debounce);
  const termo = searchInput.value.trim();
  if (!termo) { resultados.innerHTML = ''; return; }

  debounce = setTimeout(async () => {
    const data = await storefrontFetch(QUERY_BUSCA, { query: termo });
    const produtos = data?.data?.products?.edges || [];

    if (!produtos.length) {
      resultados.innerHTML = '<li class="sem-resultado">Nenhum produto encontrado</li>';
      return;
    }

    resultados.innerHTML = produtos.map(({ node }) => {
      const p = normalizarProduto(node);
      return `<li data-id="${p.id}" data-produto='${JSON.stringify(p).replace(/'/g, "&#39;")}'>
        ${p.image ? `<img src="${p.image}" alt="${p.imageAlt}">` : ''}
        <span>${p.title}</span>
      </li>`;
    }).join('');
  }, 300);
});

resultados.addEventListener('click', (e) => {
  const li = e.target.closest('li[data-produto]');
  if (!li || !produtoA) return;
  const produtoB = JSON.parse(li.dataset.produto);
  resultados.innerHTML = '';
  searchInput.value = '';

  const url = new URL(location.href);
  url.searchParams.set('compare', produtoB.id.split('/').pop());
  history.replaceState({}, '', url);

  renderTabela(produtoA, produtoB);
});

carregarProdutoA().then(async p => {
  produtoA = p;
  const compareId = new URLSearchParams(location.search).get('compare');
  if (compareId && produtoA) {
    const gid = `gid://shopify/Product/${compareId}`;
    const data = await storefrontFetch(QUERY_POR_ID, { id: gid });
    const node = data?.data?.product;
    if (node) renderTabela(produtoA, normalizarProduto(node));
  }
});
